import { IconDefinition } from '@ant-design/icons-angular'

export const MkbPlusOutline: IconDefinition = {
  name: 'mkb-plus',
  theme: 'outline',
  icon: `<svg width="34" height="34" viewBox="0 0 34 34" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.83885 25.1022C13.3299 29.5933 20.6113 29.5933 25.1023 25.1022C29.5933 20.6112 29.5933 13.3298 25.1023 8.83877C20.6113 4.34774 13.3299 4.34774 8.83885 8.83877C4.34782 13.3298 4.34782 20.6112 8.83885 25.1022Z" stroke="#E4E8ED"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1279 16.9705C12.1279 16.6391 12.3966 16.3705 12.7279 16.3705L21.2132 16.3705C21.5446 16.3705 21.8132 16.6391 21.8132 16.9705C21.8132 17.3019 21.5446 17.5705 21.2132 17.5705L12.7279 17.5705C12.3966 17.5705 12.1279 17.3019 12.1279 16.9705Z" fill="#2C96DA"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9706 12.1279C17.302 12.1279 17.5706 12.3965 17.5706 12.7279L17.5706 21.2131C17.5706 21.5445 17.302 21.8131 16.9706 21.8131C16.6392 21.8131 16.3706 21.5445 16.3706 21.2131L16.3706 12.7279C16.3706 12.3965 16.6392 12.1279 16.9706 12.1279Z" fill="#2C96DA"/>
    </svg>
   
    `,
}
